import React, { Component } from 'react';

import { ILoanAccountActivity } from '../../../interfaces';
import { FormattingUtils } from '../../../utils';

import LoanAccountActivity from './LoanAccountActivity';

const { formatDate, formatMoney } = FormattingUtils;

interface IProps {
  activity: ILoanAccountActivity;
}

/**
 * Recorded by the nightly job on the day a charge's amount settles, so it never has a person behind
 * it. Not when the charge was opened: until its final amount date the API re-prices it nightly on
 * what the account currently owes, and an entry written then would state a figure the account never
 * owed. What is here is the amount it came to, which is why nothing revises it afterwards.
 */
class ComplianceChargeFinalized extends Component<IProps> {
  public render () {
    const { data } = this.props.activity
      // Labeled as the columns of the Compliance tab are, so the same charge reads the same way in both.
      , activityBody = (
        <div>
          <h3>Compliance Charge Finalized</h3>
          <p><span className='status'>Charge:</span> {formatMoney(data.amount)}</p>
          <p><span className='status'>Principal Charged:</span> {formatMoney(data.principal_basis_amount)}</p>
          <p><span className='status'>Due:</span> {formatDate(data.due_date)}</p>
        </div>
      )
      ;

    // Passed explicitly rather than spread: a spread would let a prop added upstream override the
    // dot and icon this component picked, and the failure would be a wrong icon rather than an error.
    return (
      <LoanAccountActivity
        activity={this.props.activity}
        activity_body={activityBody}
        dot='icon'
        icon='file-text-o'
      />
    );
  }
}

export default ComplianceChargeFinalized;
